
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface HeaderProps {
  onBookingClick: () => void;
}

export default function Header({ onBookingClick }: HeaderProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Auf Unterseiten immer weißen Hintergrund zeigen
  const showWhiteBackground = isScrolled || !isHomePage;

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      showWhiteBackground ? 'bg-white shadow-sm' : 'bg-transparent'
    }`}>
      <div className="px-6 lg:px-12 py-4">
        <div className="flex items-center justify-between">
          <a href="/" className="flex items-center cursor-pointer">
            <img 
              src="/images/KLAR-ki_logo-symbol@2x.png" 
              alt="klar:ki Logo" 
              className="h-8 w-auto"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            <a 
              href="/#person"
              className={`text-sm font-normal hover:text-[#0A6AF0] transition-colors cursor-pointer ${
                showWhiteBackground ? 'text-[#042A60]' : 'text-white'
              }`}
            >
              About
            </a>
            <a 
              href="/#prozess"
              className={`text-sm font-normal hover:text-[#0A6AF0] transition-colors cursor-pointer ${
                showWhiteBackground ? 'text-[#042A60]' : 'text-white'
              }`}
            >
              Leistungen
            </a>
            <a 
              href="/#team"
              className={`text-sm font-normal hover:text-[#0A6AF0] transition-colors cursor-pointer ${
                showWhiteBackground ? 'text-[#042A60]' : 'text-white'
              }`}
            >
              KI-Team
            </a>
            <a 
              href="/faq"
              className={`text-sm font-normal hover:text-[#0A6AF0] transition-colors cursor-pointer ${
                showWhiteBackground ? 'text-[#042A60]' : 'text-white'
              }`}
            >
              FAQ
            </a>
            <a 
              href="/#contact"
              className={`text-sm font-normal hover:text-[#0A6AF0] transition-colors cursor-pointer ${
                showWhiteBackground ? 'text-[#042A60]' : 'text-white'
              }`}
            >
              Kontakt
            </a>
            <button
              onClick={onBookingClick}
              className={`px-5 py-2 text-sm font-normal border transition-colors cursor-pointer whitespace-nowrap ${
                showWhiteBackground 
                  ? 'bg-[#0A6AF0] text-white border-[#0A6AF0] hover:bg-[#042A60] hover:border-[#042A60]' 
                  : 'bg-transparent text-white border-white hover:bg-white hover:text-[#042A60]'
              }`}
            >
              Klarheitsgespräch
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
              showWhiteBackground ? 'text-[#042A60]' : 'text-white'
            }`}
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 flex flex-col gap-4 bg-white rounded-lg p-4 shadow-lg">
            <a 
              href="/#person"
              className="text-sm font-normal text-[#042A60] hover:text-[#0A6AF0] transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              About
            </a>
            <a 
              href="/#prozess"
              className="text-sm font-normal text-[#042A60] hover:text-[#0A6AF0] transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Leistungen
            </a>
            <a 
              href="/#team"
              className="text-sm font-normal text-[#042A60] hover:text-[#0A6AF0] transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              KI-Team
            </a>
            <a 
              href="/faq"
              className="text-sm font-normal text-[#042A60] hover:text-[#0A6AF0] transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              FAQ
            </a>
            <a 
              href="/#contact"
              className="text-sm font-normal text-[#042A60] hover:text-[#0A6AF0] transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Kontakt
            </a>
            <button
              onClick={() => {
                onBookingClick();
                setIsMobileMenuOpen(false);
              }}
              className="px-5 py-2 bg-[#0A6AF0] text-white text-sm font-normal hover:bg-[#042A60] transition-colors cursor-pointer whitespace-nowrap"
            >
              Klarheitsgespräch
            </button>
          </nav>
        )}
      </div>
    </header>
  );
}
